import React, { useReducer } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import { ActiveMember, CurrentUserDetails } from './context';
import activeMember from './context/activeMember';
import profile from './context/profile';
import SkillsRouter from './router';
import { getSessionStorage } from './utils';
import ReactGA from 'react-ga4';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { GOOGLE_CLIENT_ID } from './Constants';

export default function App() {
  ReactGA.initialize('G-0HPSBTRHC7');

  const { name, role, email, org, phoneNo, isAccountSetUp, roleType, userId } =
    getSessionStorage('current-profile') || {};

  const initialProfileState = {
    name,
    role,
    email,
    org,
    phoneNo,
    isAccountSetUp,
    roleType,
    userId,
  };

  const initialEditMember = {
    name: '',
    email: '',
    subscriptions: [],
    id: '',
    companyName: '',
    role: '',
    responseGenerated: '',
    assignedLeads: '',
  };
  const [profileState, profileDispatch] = useReducer(profile, initialProfileState);
  const [editMember, dispatchEditMember] = useReducer(activeMember, initialEditMember);

  return (
    <div className="app">
      <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <CurrentUserDetails.Provider value={[profileState, profileDispatch]}>
          <ActiveMember.Provider value={[editMember, dispatchEditMember]}>
            <SkillsRouter />
          </ActiveMember.Provider>
        </CurrentUserDetails.Provider>
        <ToastContainer />
      </GoogleOAuthProvider>
    </div>
  );
}
